<mat-dialog-content>
	<p mat-dialog-title>Generowanie plików</p>
	<div class="row">
		<div class="col-md-4 p-4">Rooming List</div>
		<div class="col-md-2 p-4">
			<button
				class="csv-generate-report-button"
				mat-raised-button
				color="primary"
				(click)="generateReport('rooming', 'csv')"
			>
				<span>CSV</span>
			</button>
		</div>
		<div class="col-md-2 p-4">
			<button mat-raised-button color="primary" (click)="generateReport('rooming', 'spreadsheet')">
				<span>Spreadsheet</span>
			</button>
		</div>
	</div>
	<div class="row">
		<div class="col-md-4 p-4">Lista fakultetów</div>
		<div class="col-md-2 p-4">
			<button
				class="csv-generate-report-button"
				mat-raised-button
				color="primary"
				[matTooltip]="peopleFacultiesInfo()"
				[disabled]="!peopleWithFacultiesExist()"
				(click)="downloadReport('facultative', 'csv')"
			>
				<span>CSV</span>
			</button>
		</div>
		<div class="col-md-2 p-4">
			<button
				mat-raised-button
				color="primary"
				[matTooltip]="peopleFacultiesInfo()"
				[disabled]="!peopleWithFacultiesExist()"
				(click)="downloadReport('facultative', 'spreadsheet')"
			>
				<span>Spreadsheet</span>
			</button>
		</div>
	</div>
	<div class="row">
		<div class="col-md-4 p-4">Ubezpieczenia</div>
		<div class="col-md-2 p-4">
			<button
				[disabled]="!selectedInsurer"
				mat-raised-button
				color="primary"
				(click)="downloadReport('insurance', 'csv')"
			>
				<span>CSV</span>
			</button>
		</div>
		<div class="col-md-2 p-4">
			<button
				[disabled]="!selectedInsurer"
				mat-raised-button
				color="primary"
				(click)="downloadReport('insurance', 'spreadsheet')"
			>
				<span>Spreadsheet</span>
			</button>
		</div>
		<div>
			<mat-radio-group name="selectedInsurer" [(ngModel)]="selectedInsurer">
				@for (insurer of data.insurers; track insurer) {
					<mat-radio-button [value]="insurer">
						{{ insurer }}
					</mat-radio-button>
				}
			</mat-radio-group>
		</div>
	</div>
	<hr />

	@if (product()?.productKind === ProductKindType.ROUND_TRIP) {
		<p mat-dialog-title>Ustawienie dostępności pokoi</p>
		<mat-dialog-content>
			<app-bag-transport-term-change-room-availability
				[termId]="data.offerTerm[0]"
				[productId]="product().id"
			></app-bag-transport-term-change-room-availability>
		</mat-dialog-content>
		<hr />
	}

	<p mat-dialog-title>Ogranicz max. liczbę uczestników</p>
	<mat-dialog-content>
		<div class="row">
			<div class="col-4">
				<mat-form-field appearance="outline">
					<mat-label>Wyjazd&Powrót</mat-label>
					<input
						matInput
						type="number"
						name="numberInput"
						[disabled]="!!optional.departure || !!optional.return"
						[ngModel]="optional.both"
						(ngModelChange)="setMaxSeatOptional($event, TermTourismEventSetKinds.BOTH)"
					/>
				</mat-form-field>
			</div>
			<div class="col-4">
				<mat-form-field appearance="outline">
					<mat-label>Wyjazd</mat-label>
					<input
						matInput
						type="number"
						name="numberInput"
						[disabled]="!!optional.both"
						[ngModel]="optional.departure"
						(ngModelChange)="setMaxSeatOptional($event, TermTourismEventSetKinds.DEPARTURE)"
					/>
				</mat-form-field>
			</div>
			<div class="col-4">
				<mat-form-field appearance="outline">
					<mat-label>Powrót</mat-label>
					<input
						matInput
						type="number"
						name="numberInput"
						[disabled]="!!optional.both"
						[ngModel]="optional.return"
						(ngModelChange)="setMaxSeatOptional($event, TermTourismEventSetKinds.RETURN)"
					/>
				</mat-form-field>
			</div>
		</div>
		<div class="row">
			<button mat-raised-button color="primary" (click)="patchMaxSeatOptional()" class="m-auto">
				<span>Zapisz</span>
			</button>
		</div>
		<hr />

		<p mat-dialog-title>Wydarzenia</p>
		<div class="row">
			<div class="col-9">
				<app-generic-mat-autocomplete
					[placeholder]="'Nazwa wydarzenia (tylko kategoria OSKAR, GRUPA i OSKAR SAMOLOT)'"
					[apiUrl]="environment.erpUrl + '/tourismEvents/'"
					[apiSearchParam]="apiSearchParamURL()"
					[responseMapper]="erpEventsMapper"
					[displayKeys]="['displayName']"
					[showOptionsOnFocus]="true"
					(selected)="onTourismEventsSelected($event)"
				>
				</app-generic-mat-autocomplete>
			</div>
			<div class="col-3">
				<button
					mat-raised-button
					color="primary"
					(click)="connectTourismEventToTransportTerm(chosenEvent)"
					[disabled]="!chosenEvent"
					class="m-auto"
				>
					<span>Połącz</span>
				</button>
			</div>
		</div>
		<div class="row overflow-scroll mh-240">
			<table class="table">
				<thead>
					<tr>
						<th>Nazwa</th>
						<th>Ilość siedzeń</th>
						<th>Załoga</th>
						<th>Typ</th>
						<th>Usuń</th>
					</tr>
				</thead>
				<tbody>
					@for (event of data.termtourismeventSet; track event.eventId; let i = $index) {
						<tr>
							<td class="align-middle">{{ event.eventName }}</td>
							<td>
								<mat-form-field>
									<input matInput type="number" disabled="true" [(ngModel)]="event.maxSeat" />
								</mat-form-field>
							</td>
							<td>
								<mat-form-field>
									<input matInput type="number" [(ngModel)]="event.crewCount" />
								</mat-form-field>
							</td>
							<td>
								<mat-form-field>
									<mat-select (opened)="checkOptionsToDisable(event)" [(ngModel)]="event.kind">
										@for (item of mappedTourismEventsKinds; track item.kind) {
											<mat-option [disabled]="item.disable" [value]="item.kind">{{
												item.name
											}}</mat-option>
										}
									</mat-select>
								</mat-form-field>
							</td>
							<td class="align-middle">
								<button mat-icon-button color="warn" (click)="removeEvent(i)">X</button>
							</td>
						</tr>
					}
				</tbody>
			</table>
		</div>
		<div class="row mx-2 pt-2">
			<button mat-raised-button color="primary" (click)="saveTourismEvents()" class="m-auto">
				<span>Zapisz wydarzenia</span>
			</button>
		</div>
	</mat-dialog-content>
	<mat-dialog-content>
		<app-note-list
			[view]="'tab'"
			[tableName]="TableName.SEASON_TERM"
			[tableId]="data.id"
			[disableHiding]="true"
		></app-note-list>
	</mat-dialog-content>
	<mat-dialog-content>
		<app-tasks-list [tableId]="data.id" [tableName]="TableName.SEASON_TERM" [view]="'tab'"></app-tasks-list>
	</mat-dialog-content>
</mat-dialog-content>
